// src/Components/Admin/AdminLayout.js
import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopbar from "./AdminTopbar";
import client from "../../api/client";
import "./AdminLayout.css";

export default function AdminLayout({ children }) {
  const [isAdmin, setIsAdmin] = useState(null); // null=loading, true/false set

  useEffect(() => {
    let active = true;

    async function verifyAdmin() {
      try {
        // Prefer separate admin token stored by admin login flow
        const adminToken = localStorage.getItem("admin_token") || localStorage.getItem("adminToken");
        const fallbackUserToken = localStorage.getItem("token");

        const headers = {};
        if (adminToken && adminToken !== "null" && adminToken !== "undefined") {
          headers.Authorization = `Bearer ${adminToken}`;
        } else if (fallbackUserToken && fallbackUserToken !== "null" && fallbackUserToken !== "undefined") {
          headers.Authorization = `Bearer ${fallbackUserToken}`;
        } else {
          // no token -> not admin
          if (active) setIsAdmin(false);
          return;
        }

        // call admin/me explicitly with chosen header (don't rely only on interceptor)
        const res = await client.get("/api/admin/me", { headers });
        if (!active) return;

        if (res?.data?.ok && res.data.admin) {
          // good admin session
          setIsAdmin(true);
          // optionally persist admin info for UI
          try { localStorage.setItem("admin_user", JSON.stringify(res.data.admin)); } catch (e) {}
        } else {
          setIsAdmin(false);
        }
      } catch (err) {
        console.warn("Admin check failed:", err?.response?.status || err?.message || err);
        if (active) setIsAdmin(false);
      }
    }

    verifyAdmin();
    return () => { active = false; };
  }, []);

  if (isAdmin === null) {
    return <div style={{ display: "flex", justifyContent: "center", marginTop: 80 }}><h3>Checking admin access…</h3></div>;
  }

  if (isAdmin === false) {
    return (
      <div style={{ padding: 60, textAlign: "center" }}>
        <h2>🚫 Access Denied</h2>
        <p>You are not authorized to view the admin panel.</p>
        <div style={{ marginTop: 20 }}>
          <button
            onClick={() => {
              localStorage.removeItem("admin_token");
              localStorage.removeItem("admin_user");
              // optional: also remove generic token so user is not accidentally using wrong one
              // localStorage.removeItem("token");
              window.location.href = "/admin/login";
            }}
            style={{ padding: "8px 14px", cursor: "pointer" }}
          >
            Go to Admin Login
          </button>
        </div>
      </div>
    );
  }

  // Admin allowed
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <AdminSidebar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <AdminTopbar />
        <main style={{ padding: 20, background: "#f6f7fb", minHeight: "calc(100vh - 64px)" }}>
          {children}
        </main>
      </div>
    </div>
  );
}
